export default "__VITE_ASSET__JGl7qjAC__"